import React from 'react';
import style from './exclusiveContent.module.css';
import { arrayOf, element, oneOf, oneOfType } from 'prop-types';

ExclusiveContent.propTypes = {
  children: oneOfType([element, arrayOf(element)]),
  collapseMode: oneOf(['display', 'visibility']),
};

ExclusiveContent.defaultProps = {
  collapseMode: 'display',
};

export default ExclusiveContent;

function ExclusiveContent({ children, collapseMode, ...props }) {
  return (
    <div
      className={style.exclusiveContent}
      data-collapse-mode={collapseMode}
      {...props}
    >
      {children}
    </div>
  );
}
